import { Button, Flex } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { MealCreditTitle } from 'src/components/oneCorp/features/MealCredit/components/Headers/MealCreditTitle';
import { useMealCreditHeaderControl } from 'src/components/oneCorp/features/MealCredit/hooks/useMealCreditHeaderControl';
import { SimpleDialog } from 'src/components/SimpleDialog/SimpleDialog';

export interface MealCreditHeaderProps {
  corpId: string;
  mealCreditId: string;
}
export function MealCreditHeader({
  corpId,
  mealCreditId,
}: MealCreditHeaderProps): JSX.Element {
  const {
    isDeactivating,
    deactivateMealCredit,
    showDeactivateModal,
    confirmDeactivation,
    closeDeactivateModal,
  } = useMealCreditHeaderControl({
    corpId,
    mealCreditId,
  });

  return (
    <>
      <Flex justifyContent="space-between">
        <MealCreditTitle title="Your Meal credit" corpId={corpId} />
        <Button
          variant="secondary"
          buttonSize="small"
          onClick={confirmDeactivation}
        >
          Deactivate credit
        </Button>
      </Flex>
      {showDeactivateModal && (
        <SimpleDialog
          isPrimaryButtonLoading={isDeactivating}
          disablePrimaryActionButton={isDeactivating}
          disableSecondaryActionButton={isDeactivating}
          id={mealCreditId}
          primaryActionFlavor="danger"
          title="Deactivate meal credit?"
          description="Once your meal credit becomes inactive, you cannot reactivate it and won’t be available at checkout when employees check out."
          primaryActionText="Deactivate"
          buttonsDirection="row"
          secondaryActionText="Cancel"
          onPrimaryActionClick={async () => deactivateMealCredit()}
          onSecondaryActionClick={closeDeactivateModal}
        />
      )}
    </>
  );
}
